import {
  SHOW_FILTER_PANEL,
  HIDE_FILTER_PANEL,
  GET_ASSIGNEES_SUCCESS,
  GET_ASSIGNEES_INFINITE_SUCCESS
} from './filterPanelActionTypes';
import { TASKS } from '../insertTask/insertTaskActionTypes';
import filterPanelUtilsTasks from '../../common/components/FilterPanel/FilterPanelDataUtilsTasks';
import remapFilters from './filterReducer';

const initialState = {
  filters: filterPanelUtilsTasks.filters
};

const getInitialStateFilters = (filterName) =>
  filterName === TASKS ? { filters: filterPanelUtilsTasks.filters } : { filters: [] };

export default function queryParams(queryName = '') {
  return function params(state = initialState, action = {}) {
    switch (action.type) {
      case `${SHOW_FILTER_PANEL}_${queryName}`: {
        return {
          ...getInitialStateFilters(queryName),
          showFilterConditions: false
        };
      }
      case `${HIDE_FILTER_PANEL}_${queryName}`: {
        return { ...state, shown: false, showFilterConditions: false };
      }
      case GET_ASSIGNEES_INFINITE_SUCCESS:
      case GET_ASSIGNEES_SUCCESS: {
        return {
          ...state,
          filters: remapFilters(state.filters, action, 'assignee')
        };
      }
      default:
        return state;
    }
  };
}
